import fontUrlMediumWoff from 'assets/fonts/poppins-v20-latin-500.woff';
import fontUrlMediumWoff2 from 'assets/fonts/poppins-v20-latin-500.woff2';
import fontUrlSemiBoldWoff from 'assets/fonts/poppins-v20-latin-600.woff';
import fontUrlSemiBoldWoff2 from 'assets/fonts/poppins-v20-latin-600.woff2';
import fontUrlBoldWoff from 'assets/fonts/poppins-v20-latin-700.woff';
import fontUrlBoldWoff2 from 'assets/fonts/poppins-v20-latin-700.woff2';
import fontUrlRegularWoff from 'assets/fonts/poppins-v20-latin-regular.woff';
import fontUrlRegularWoff2 from 'assets/fonts/poppins-v20-latin-regular.woff2';

import { globalCss } from '@clubspark-react/ui/components/stitches.config';

const poppinsFont = [
  {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `local(""), url("${fontUrlRegularWoff2}") format("woff2"), url("${fontUrlRegularWoff}") format("woff")`,
  },
  {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    src: `local(""), url("${fontUrlMediumWoff2}") format("woff2"), url("${fontUrlMediumWoff}") format("woff")`,
  },
  {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 600,
    src: `local(""), url("${fontUrlSemiBoldWoff2}") format("woff2"), url("${fontUrlSemiBoldWoff}") format("woff")`,
  },
  {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 700,
    src: `local(""), url("${fontUrlBoldWoff2}") format("woff2"), url("${fontUrlBoldWoff}") format("woff")`,
  },
];

export const usePoppinsFont = globalCss({
  '@font-face': poppinsFont,
});

export default usePoppinsFont;
